'use strict';

var helper = require('../helper');

module.exports = {
    pushAfterpayModalInteraction (page) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '76',
            'eventname': 'payment_info',
            'payment_method': 'afterpay'
        };

        helper.log('Pushing Afterpay modal interaction', true);
        helper.push(pushObject);
    }
};
